<template>
  <div class="checkOthers vipBg">
    <div class="titleBar1" v-if="isVip">
      <div class="title vip">
        <i class="ico_member"></i>查验他人

        <!-- <Guide /> -->
        <!-- <span
          class="guide"
          @click="dialogGuide = true"
          ><i class="ico_question">?</i>新手引导</span
        > -->
      </div>
      <div class="records" @click="$router.push('records')">
        我的查验记录<i class="icon_arrow_right_gold" />
      </div>
      <!-- <div class="pageHeadBack" @click="$router.go(-1)">&lt; 返回</div> -->
      <div class="topBg"></div>
    </div>
    
    <div v-else class="titleBar">
      <div class="title">
        查验他人
        <!-- <span class="guide" @click="dialogGuide = true"
          ><i class="ico_question">?</i>新手引导</span
        > -->
        <!-- <Guide /> -->
      </div>
      <!-- <div class="pageHeadBack" @click="$router.go(-1)">&lt; 返回</div> -->
      <div class="records" @click="$router.push('records')">
        我的查验记录<i class="icon_arrow_right" />
      </div>
    </div>
    
    <QA position="checkOthers"/>

    <div class="formLayout">
      <div class="formTitle vipTitle" v-if="isVip">
        尊贵的年费用户，您可通过他人姓名、手机号向其申请实名查验，获得对方同意及授权后可查验其个人信息报告
      </div>
      <div class="formTitle " v-else>
        <div class="pic_noVip"></div>
        您可通过他人姓名、手机号向其申请实名查验，获得对方同意及授权后可查验其个人信息报告。
      </div>
      <el-form
        ref="dataForm"
        label-width="150px"
        label-position="left"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="请输入对方姓名：" prop="name">
          <el-input
            placeholder="请输入"
            v-model="form.name"
            style="width:203px;height:37px"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入对方手机号：" prop="phone">
          <el-input
            placeholder="请输入"
            v-model="form.phone"
            style="width:203px;height:37px"
          ></el-input>
        </el-form-item>
        <!-- <div>您的剩余免费查验次数：6</div> -->
        <el-form-item
          v-if="isVip"
          label="您的剩余免费查验次数："
          label-width="166px"
        >
          <span style="color:#FF5129">{{ times }}</span>
        </el-form-item>
        <!-- <el-form-item></el-form-item> -->
      </el-form>
      <button
        :class="`btn_goCheck ${isVip ? 'btnVip' : ''}`"
        @click="goCheckOrBuyVip"
      >
        发起查验申请
      </button>
    </div>

    <div class="circle" v-if="isVip"></div>
    <!-- <div v-if="dialogGuide">
      <Cover
        :dialogGuide="dialogGuide"
        @dialogGuideClose="handleDialogGuideClose"
      >
        <ul slot="content">
          <li>
            <div>发起查验：</div>
            <div>
              您可以通过对方姓名、手机号发起实名查验申请。
            </div>
          </li>
          <li>
            <div>同意授权：</div>
            <div>
              对方同意并授权其个人信息报告给您授权查验，您可在查验记录中查看。
            </div>
          </li>
          <li>
            <div>拒绝授权：</div>
            <div>
              对方拒绝向您授权其个人信息报告。
            </div>
          </li>
        </ul>
      </Cover>
    </div> -->
    <div v-if="dialogBuyVip">
      <PayMember
        :socket-id="_socketId"
        @handleClose="handleDialagPayClose"
        payType="INSPECTION_SINGLE_PAYMENT"
        title="查验他人"
      >
        <div slot="coverFooter" style="text-align: center;">
          <Btn
            btnText="支付完成"
            className="primary"
            :width="120"
            style="margin-top:30px"
            @handleClick="handlePayDone"
          />
        </div>
      </PayMember>
    </div>
  </div>
</template>

<script>
import BuyMember from "../../../components/BuyMember.vue";
import Cover from "../../../components/Cover.vue";
import CoverLayout from "../../../components/CoverLayout.vue";
import PayInfo from "../../../components/payInfo.vue";
import { inspectionApply, inspectionTimeCheck } from "@/api/inspection";
import PayMember from "../../../components/PayMember.vue";
import Btn from "../../../components/Btn.vue";
import { getUserInfo } from "@/api/user";
import Guide from "@/components/Guide.vue";
import { webSocketMixin } from '@/utils/mixins.js'
import QA from '../../../components/QA.vue';
export default {
  mixins: [webSocketMixin],
  components: { Cover, CoverLayout, BuyMember, PayInfo, PayMember, Btn, Guide, QA },

  data() {
    return {
      dialogGuide: false,
      isVip: JSON.parse(sessionStorage.getItem("userInfo")).status === "4",
      dialogBuyVip: false,
      form: {
        name: "",
        phone: ""
      },
      times: 0,
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }]
      }
    };
  },
  created() {
    this.checkTimes();
    if (JSON.parse(localStorage.getItem("checkOtherInfo"))) {
      this.form = JSON.parse(localStorage.getItem("checkOtherInfo"));
    }
    this.getUser();
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("checkOtherInfo");
    window.onresize = "";
    next();
  },
  methods: {
    handleDialogGuideClose(flag) {
      this.dialogGuide = flag;
    },
    goCheckOrBuyVip() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // this.checkTimes();
          inspectionTimeCheck().then(res => {
            if (res.data.d === 0) {
              this._initSocket()
              this._socket.onmessage = (e) => {
                let { data } = e
                if (data) {
                  data = JSON.parse(data)
                  console.log(data)
                  const { type, paySuccess, message } = data
                  if (type === 2 && paySuccess) {
                    // this.handleResult()
                    this.handlePayDone()
                  }
                }
              }
              this.dialogBuyVip = true;
            } else {
              inspectionApply(this.form).then(res => {
                if (res.data.c === 200) {
                  this.$message.success("查验申请成功");
                  this.$router.push("records");
                  localStorage.removeItem("checkOtherInfo");
                }
              });
            }
          });
          // if (this.times === 0) {
          //   this.dialogBuyVip = true;
          // } else {
          //   inspectionApply(this.form).then(res => {
          //     if (res.data.c === 200) {
          //       this.$message.success("查验申请成功");
          //       this.$router.push("records");
          //       localStorage.removeItem("checkOtherInfo");
          //     }
          //   });
          // }
        }
      });
    },
    async getUser() {
      await getUserInfo().then(res => {
        if (res.data.c === 200) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
        }
      });
    },
    async checkTimes() {
      await inspectionTimeCheck().then(res => {
        this.times = res.data.d;
      });
    },
    handlePayDone() {
      this.dialogBuyVip = false;
      inspectionApply(this.form).then(res => {
        // console.log(res);
        if (res.data.c === 200) {
          this.$message.success("查验成功");
          this.getUser();
          this.$router.push("records");
          localStorage.removeItem("checkOtherInfo");
        }
      });

      // this.checkTimes();
    },
    handleDialagPayClose() {
      this.dialogBuyVip = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.vipBg {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/co_bg.png")
    no-repeat;
  background-color: #fff;
  background-position: bottom right;
  background-size: 477px;
}
.checkOthers {
  position: relative;
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;

  .el-form-item {
    margin-bottom: 18px;
  }
  .vip {
    .title {
      &::after {
        //   content: "";
        //   border-left: 3px solid #3a61b1;
        //   height: 16px;
        //   position: absolute;
        //   left: 0;
        //   top: 6px;
      }
    }
  }
  .titleBar1 {
    display: flex;
    justify-content: space-between;
    z-index: 1;
    .records {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #653e12;
      cursor: pointer;
      .icon_arrow_right_gold {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_right_gold.png");
        background-size: cover;
        width: 7px;
        height: 12px;
        display: inline-block;
        // transform: rotate(180deg);
        margin-left: 14px;
      }
    }
    .title {
      color: #393939;
      font-weight: bold;
      font-size: 20px;
      position: relative;
      padding-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      display: flex;
      align-items: center;
      color: #653e12;
      font-size: 20px;
      font-weight: bold;
      .ico_member {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/btn_icon_vip.png")
          no-repeat;
        background-size: cover;
        display: inline-block;
        width: 29px;
        height: 21px;
        margin-right: 8px;
      }

      .guide {
        font-size: 14px;
        color: #6e6e6e;
        font-weight: normal;
        cursor: pointer;
        .ico_question {
          background: #ff8d65;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 15px;
          margin-right: 5px;
          margin-left: 12px;
          font-style: normal;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .pageHeadBack {
      color: #653e12;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .titleBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    .records {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #8d8d8d;
      // line-height: 41px;
      cursor: pointer;
      .icon_arrow_right {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png");
        background-size: cover;
        width: 7px;
        height: 12px;
        display: inline-block;
        transform: rotate(180deg);
        margin-left: 14px;
      }
    }
    .title {
      color: #393939;
      font-weight: bold;
      font-size: 20px;
      position: relative;
      padding-left: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        content: "";
        border-left: 3px solid #3a61b1;
        height: 16px;
        position: absolute;
        left: 0;
        top: 5px;
      }
      display: flex;
      align-items: center;
      // color: #653e12;
      font-size: 20px;
      font-weight: bold;
      .ico_member {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_memberV.png")
          no-repeat;
        background-size: cover;
        display: inline-block;
        width: 23px;
        height: 26px;
        margin-right: 15px;
      }
      .guide {
        font-size: 14px;
        color: #6e6e6e;
        font-weight: normal;
        cursor: pointer;
        .ico_question {
          background: #ff8d65;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 15px;
          margin-right: 5px;
          margin-left: 12px;
          font-style: normal;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .pageHeadBack {
      color: #653e12;
      font-size: 20px;
    }
  }
  .topBg {
    background: linear-gradient(#e8b174, #fff);
    width: 100%;
    height: 179px;
    position: absolute;
    opacity: 0.26;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .circle {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/co_circle.png")
      no-repeat;
    background-size: cover;
    width: 99px;
    height: 99px;
    position: absolute;
    top: 478px;
    left: 90px;
  }
  .pic_noVip {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/co_noVip.png")
      no-repeat;
    background-size: cover;
    width: 340px;
    height: 300px;
    margin-bottom: 47px;
  }
  .formLayout {
    display: flex;
    flex-direction: column;
    align-items: center;
    .formTitle {
      padding: 45px 154px 49px 154px;
      text-align: center;
      width: 439px;
      color: #7e7e7e;
      font-size: 20px;
    }
    .vipTitle {
      color: #653e12;
      padding: 199px 154px 49px 154px;
      width: 538px;
      line-height: 30px;
    }
  }
  .btn_goCheck {
    width: 164px;
    height: 41px;
    background: #3a61b1;
    color: #fff;
    border-radius: 25px;
    border: 0;
    font-size: 16px;
    margin-bottom: 110px;
    margin-top: 42px;
  }
  .btnVip {
    width: 200px;
    height: 50px;
    background: #e5c7a3;
    color: #653e12;
    font-size: 18px;
    margin-bottom: 272px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/checkOthers/index.vue